export class GetLomBuildingsByAddressCriteriaQuery {
  areaId: string;
  street: string;
  number: string;
  suffix: string;
  postalCode: string;
  city: string;
  lomKey: string;

  constructor(query: {
    areaId?: string;
    street?: string;
    number?: string;
    suffix?: string;
    postalCode?: string;
    city?: string;
    lomKey?: string;
  }) {
    this.areaId = query.areaId;
    this.street = query.street;
    this.number = query.number;
    this.suffix = query.suffix;
    this.postalCode = query.postalCode;
    this.city = query.city;
    this.lomKey = query.lomKey;
  }
}
